import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditSummarizeNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditSummarizeNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditSummarizeNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of data to process',
            default: 'default'
        },
        input_key: {
            title: 'Input Key',
            type: 'string',
            description: 'Key of data to process if applicable. Use value_one/value_two for nested data',
        },
        data_type: {
            title: 'Data Type',
            type: 'string',
            enum: [
                'Text',
                'Array',
                'Number',
                // 'Data Model'
            ],
            default: 'Text'
        },
        process_method: {
            title: 'Process Method',
            type: 'string',
            enum: [
                'All Lowercase',
                'All Uppercase',
                'Capitalize',
                'Concatenate',
                'Text Length',
                'Replace with Text',
                'Count',
                'Explode to Text (Comma Separated Values)',
                'Max',
                'Min',
                'Sum',
                'Average',
                'Add Number',
                'Subtract Number',
                'Multiply Number',
                'Divide Number'
            ],
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store summarize response',
            default: 'default'
        }
    },
    allOf: [
        // {
        //     if: {
        //         properties: {
        //             data_type: {
        //                 const: 'Data Model'
        //             }
        //         }
        //     },
        //     then: {
        //         properties: {
        //             process_method: {
        //                 enum: [
        //                     'All Lowercase',
        //                     'All Uppercase',
        //                     'Capitalize',
        //                     'Concatenate',
        //                     'Text Length',
        //                     'Count',
        //                     'Explode to Text',
        //                     'Max',
        //                     'Min',
        //                     'Sum',
        //                     'Average'
        //                 ],
        //                 default: 'Capitalize'
        //             },
        //             model_key: {
        //                 title: 'Model Key',
        //                 type: 'string',
        //                 description: 'Value to target model values, use value_one/value_two for nested values'
        //             }
        //         },
        //         required: ['model_key']
        //     }
        // },
        {
            if: {
                properties: {
                    data_type: {
                        const: 'Text'
                    }
                }
            },
            then: {
                properties: {
                    process_method: {
                        default: 'Capitalize'
                    },
                },
                allOf: [
                    {
                        if: {
                            properties: {
                                process_method: {
                                    const: 'Concatenate'
                                }
                            }
                        },
                        then: {
                            properties: {
                                'separator': {
                                    title: 'Separator',
                                    type: 'string',
                                    default: ' '
                                },
                                data_inputs: {
                                    title: 'Location of data to concatenate',
                                    type: 'array',
                                    items: {
                                        title: '',
                                        type: 'object',
                                        properties: {
                                            'data_input': {
                                                title: 'Data Input',
                                                type: 'string',
                                                description: 'Location of data to process',
                                                default: 'default'
                                            },
                                            input_key: {
                                                title: 'Input Key',
                                                type: 'string'
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    {
                        if: {
                            properties: {
                                process_method: {
                                    const: 'Replace with Text'
                                }
                            }
                        },
                        then: {
                            properties: {
                                'replace_text': {
                                    title: 'Search For Text',
                                    type: 'string',
                                    description: 'Text to replace with',
                                },
                                'replace_with_text': {
                                    title: 'Replace With Text',
                                    type: 'string',
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            if: {
                properties: {
                    data_type: {
                        const: 'Array'
                    }
                }
            },
            then: {
                properties: {
                    process_method: {
                        default: 'Count'
                    }
                },

            }
        },
        {
            if: {
                properties: {
                    data_type: {
                        const: 'Number'
                    }
                }
            },
            then: {
                properties: {
                    process_method: {
                        default: 'Max'
                    },

                },

            }
        },

        {
            if: {
                properties: {
                    process_method: {
                        const: 'Max',
                    },

                }
            },
            then: {
                properties: {
                    data_inputs: {
                        title: 'Location of numbers to process',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                'data_input': {
                                    title: 'Data Input',
                                    type: 'string',
                                    description: 'Location of data to process',
                                    default: 'default'
                                },
                                input_key: {
                                    title: 'Input Key',
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },


        {
            if: {
                properties: {
                    process_method: {
                        const: 'Min',
                    },

                }
            },
            then: {
                properties: {
                    data_inputs: {
                        title: 'Location of numbers to process',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                'data_input': {
                                    title: 'Data Input',
                                    type: 'string',
                                    description: 'Location of data to process',
                                    default: 'default'
                                },
                                input_key: {
                                    title: 'Input Key',
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },


        {
            if: {
                properties: {
                    process_method: {
                        const: 'Sum',
                    },

                }
            },
            then: {
                properties: {
                    data_inputs: {
                        title: 'Location of numbers to process',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                'data_input': {
                                    title: 'Data Input',
                                    type: 'string',
                                    description: 'Location of data to process',
                                    default: 'default'
                                },
                                input_key: {
                                    title: 'Input Key',
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },


        {
            if: {
                properties: {
                    process_method: {
                        const: 'Average',
                    },

                }
            },
            then: {
                properties: {
                    data_inputs: {
                        title: 'Location of numbers to process',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                'data_input': {
                                    title: 'Data Input',
                                    type: 'string',
                                    description: 'Location of data to process',
                                    default: 'default'
                                },
                                input_key: {
                                    title: 'Input Key',
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },


        {
            if: {
                properties: {
                    process_method: {
                        const: 'Add Number',
                    },

                }
            },
            then: {
                properties: {
                    add_number: {
                        title: 'Add Number',
                        type: 'string',
                    }
                }
            }
        },

        {
            if: {
                properties: {
                    process_method: {
                        const: 'Subtract Number',
                    },

                }
            },
            then: {
                properties: {
                    subtract_number: {
                        title: 'Subtract Number',
                        type: 'string',
                    }
                }
            }
        },

        {
            if: {
                properties: {
                    process_method: {
                        const: 'Multiply Number',
                    },

                }
            },
            then: {
                properties: {
                    multiply_number: {
                        title: 'Multiply Number',
                        type: 'string',
                    }
                }
            }
        },

        {
            if: {
                properties: {
                    process_method: {
                        const: 'Divide Number',
                    },

                }
            },
            then: {
                properties: {
                    divide_number: {
                        title: 'Divide Number',
                        type: 'string',
                    }
                }
            }
        },


        {
            if: {
                properties: {
                    process_method: {
                        const: 'Explode to Text'
                    },
                }
            },
            then: {
                properties: {
                    process_method: {
                        description: "Separate out elements into one string with separator value"
                    },
                    'separator': {
                        title: 'Separator',
                        type: 'string',
                        default: ' '
                    },
                }
            }
        },
        {
            if: {
                properties: {
                    process_method: {
                        const: 'Concatenate'
                    },
                }
            },
            then: {
                properties: {
                    process_method: {
                        description: 'Combine all selected inputs into one text value'
                    },
                    'separator': {
                        title: 'Separator',
                        type: 'string',
                        default: ' '
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to run small functional actions on the data depending on the data type.\n" +
    "The results of the node are stored in the Data Store Slot\n";